var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.66602H2C1.72667 5.66602 1.5 5.43935 1.5 5.16602C1.5 4.89268 1.72667 4.66602 2 4.66602H14C14.2733 4.66602 14.5 4.89268 14.5 5.16602C14.5 5.43935 14.2733 5.66602 14 5.66602Z",
    fill: "#96999C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9H4C3.72667 9 3.5 8.77333 3.5 8.5C3.5 8.22667 3.72667 8 4 8H12C12.2733 8 12.5 8.22667 12.5 8.5C12.5 8.77333 12.2733 9 12 9Z",
    fill: "#96999C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33335 12.334H6.66669C6.39335 12.334 6.16669 12.1073 6.16669 11.834C6.16669 11.5607 6.39335 11.334 6.66669 11.334H9.33335C9.60669 11.334 9.83335 11.5607 9.83335 11.834C9.83335 12.1073 9.60669 12.334 9.33335 12.334Z",
    fill: "#96999C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.8baf8bcc7d1c5b9161a1524f1f5b0056.svg";
export { ForwardRef as ReactComponent };